// German for the #-picker.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Insert a reference': 'Referenz einfügen',
}, 'RefSuggest');
